import React, {Fragment} from 'react';
import { Container } from 'react-bootstrap';
import NavMenu from './nav';

const Template = ({children}) =>{
    return (
        <Fragment>
            <Container fluid>
                {children}
            </Container>
        </Fragment>
    )
}

export default Template;